<svg width="100%" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_281_112)">
<g clip-path="url(#clip1_281_112)">
<path d="M12.41 6.75L13 2L10.57 4.92" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M18.57 12.91L21 10H15.66" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M8 8L3 14H12L11 22L16 16" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M1 1L23 23" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
</g>
</g>
<defs>
<clipPath id="clip0_281_112">
<rect width="24" height="24" fill="white"/>
</clipPath>
<clipPath id="clip1_281_112">
<rect width="24" height="24" fill="white"/>
</clipPath>
</defs>
</svg>
